import { render, staticRenderFns } from "./GoodsSettingSelector.vue?vue&type=template&id=87fe1dce&scoped=true&"
import script from "./GoodsSettingSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingSelector.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingSelector.vue?vue&type=style&index=0&id=87fe1dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe1dce",
  null
  
)

export default component.exports